import { createSkinDocument } from "./document";
import {
  RGBA_CHANNELS,
  SKIN_PIXEL_COUNT,
  SKIN_SIZE,
  type SkinDocument,
  type SkinModel,
  type SkinSize,
} from "./types";

interface EncodedSkin {
  palette: readonly number[];
  indices: string;
}

// Extracted from Minecraft Java 26.2 client.jar:
// assets/minecraft/textures/entity/player/wide/steve.png
// Source PNG SHA-256: 06628f9cef88520da742ab280a01677ce17c99717f964ed89ed791673121094c
const STEVE: EncodedSkin = {
  palette: [
    0, 0, 0, 0, 43, 30, 13, 255, 51, 36, 17, 255, 129, 83, 57, 255, 63, 42, 21,
    255, 118, 75, 51, 255, 144, 89, 63, 255, 143, 94, 62, 255, 73, 37, 16, 255,
    36, 24, 8, 255, 155, 99, 73, 255, 179, 121, 94, 255, 183, 131, 107, 255,
    170, 114, 89, 255, 52, 37, 18, 255, 255, 255, 255, 255, 82, 61, 137, 255,
    106, 64, 48, 255, 148, 96, 62, 255, 119, 66, 53, 255, 66, 29, 10, 255, 38,
    26, 10, 255, 58, 49, 137, 255, 55, 55, 55, 255, 40, 40, 40, 255, 0, 204,
    204, 255, 0, 175, 175, 255, 0, 164, 164, 255, 10, 188, 188, 255, 65, 53,
    155, 255, 70, 58, 165, 255, 4, 149, 149, 255, 0, 127, 127, 255, 5, 136, 136,
    255, 0, 104, 104, 255, 3, 122, 122, 255, 74, 74, 74, 255, 63, 63, 63, 255,
    85, 85, 85, 255,
  ],
  indices:
    "AAAAAAAAAAABAQIBAQICAQMDAwMDAwMDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AQIEAQIEAgEDAwUFBQUDAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEEAgECAQIB" +
    "BgUFBQUFBQYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAgECAgIBAgYFBQUFBQUG" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQEBAgQBAgQGAwUFBQUDBgAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICAQECAQQEAwYDAwMDBgcAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACBAIBAgICAgcDBwMHAwcDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQICAQQCAQEDBwgICAgDBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAABAQICAQkBAQICBAQEBAIBAQEJAQICAQEBAgEBCQECAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AQIBAQkJAgIJAgIEBAIEAgQCCQkBAQIBAQIEAQkJAgQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIEAgEBAgQC" +
    "AQoLDAsNCg4CBAIBAQQCAgECAgEBCQICAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABCQECAgkBAQoNCwsNDQ0K" +
    "AQEJAgIBCQECAgECAQEBAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQIBAgEGCgkNDxANChAPDQkKBgECAQIB" +
    "AgkJAgIBCQIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICAQIJCgoKCg0NERENDQoKCgoJAgECAgEJCQECCQkB" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAJAQkGCgcDEgYHCBMTFAcDEgMHCgYJAQkBCQkBAQkJAQAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwYGCgcKBwMSAxQIFAgDBwYHCgcKBgYDAwMVFRUVAwMAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAWFhYWFxcYGAAAAAAAAAAAGQ0KBgYKDRkWFhYWFhYWFgAAAAAAAAAAGhoaGwoNDQ0AAAAA" +
    "AAAAAAAAAAAAAAAAFhYWFhgYFxcAAAAAAAAAABkKBgYGBgoZFhYWFhYWFhYAAAAAAAAAABoaGhsNDQoGAAAAAAAAAAAAAAAA" +
    "AAAAABYWFhYXFxgYAAAAAAAAAAAZCgYGBgYKGRYWFhYWFhYWAAAAAAAAAAAaHBobDQ0NDQAAAAAAAAAAAAAAAAAAAAAWFhYW" +
    "GBgXFwAAAAAAAAAAGQ0KBgYKDRkWFhYWFhYWFgAAAAAAAAAAGxoaGwoNCgYAAAAAAAAAAAAAAAAdHRYdHh4eFh0WHR0dHh4W" +
    "Hx8fHxobDQoKDRsaHx8fHxobGx8fHxsaGhoaGxsbGhogICAgGhoaGgAAAAAAAAAAHRYWHR4eHhYdFh0dHh4eHh8hIR8aGh8N" +
    "DR8aGh8hIR8aGhoaGxoaGhoaGxsbGhoaICIiIBobGxoAAAAAAAAAAB0WHR0eHh4dHRYdHR4eHh4hIyMhGxobGiEbGhshIyMh" +
    "HxoaGh8aGh8aGxsaGhobHyAiIiAaGhsbAAAAAAAAAAAdFh0dHh4eHR0WHR0eHR0eIyMjIx8aGhofGhofIyMjIxsaGhsfGhob" +
    "ICAgICAgICAiIiIiICAgIAAAAAAAAAAAHRYdHR0WFh0dHRYdFhYWFiMjIyMhGxoaHxoaISMjIyMbGhofGxoaGwoKCgYKBgoG" +
    "BgYGBgYKCgoAAAAAAAAAAB0WHR0eHR0eHRYWHR0WFh0hIyMhIRsbGh8aGiEhIyMhHxoaHxoaGh8NDQ0KDQoNDQoGCgoNDQ0N" +
    "AAAAAAAAAAAdFh0dHh4eHh0WHR0eHh4eISEhIR8aGhsfGxohISEhIR8aGhsaGhsfCg0NDQ0KDQoKBgoKDQoKDQAAAAAAAAAA" +
    "HR0dHR4eHh4dFh0dHh4eHh8hIR8hGhofGxsbHx8hIR8fGhobGhsbHwoNDQ0NDQ0KCgYKBg0NDQ0AAAAAAAAAABYWHR0eHh0d" +
    "HR0WFh0dHR0fIR8fIR8bHxoaGx8fHyEfGxoaGxsbHyEKDQoNDQ0NCgoKCgYNDQ0NAAAAAAAAAAAkJBYWFhYWFhYWJCQkJCQk" +
    "Hx8fHyEfHyEbGhofHx8fHxsbGx8bHyEhDQ0KDQ0NDQ0KCgoKDQ0NDQAAAAAAAAAAFyUkJCQmJCQkJCUXJSQkJR0WHRYWFh0d" +
    "FiEbHyEWFh0dIR8hHyEWHg0NCg0NDQoNCgoKCg0KDQ0AAAAAAAAAABcXFyUlJCQlJRcXFxclJRcdFh0dHR4eHR4dISEdFh0d" +
    "Hh4dFiEdHh4KDQ0KCg0KCgYKBgoKCg0KAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAABwcHBwcHBwaGxsbGxocHBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWFhYW" +
    "GBgXFwAAAAAAAAAAGxoaGg0NDQoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFhYWFhcXGBgAAAAA" +
    "AAAAABsaGhoGCg0NAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYWFhYYGBcXAAAAAAAAAAAbGhwa" +
    "DQ0NDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAWFhYWFxcYGAAAAAAAAAAAGxoaGwYKDQoAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdHRYdHh4dHR0WHR0eHh4dICAgIBoaGxsbGhoaGhoaGgAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHR0WHR0eHh4dFhYdHh4eHiAiIiAaGhobGxsaGhobGxoAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAB0dFh0WHh4eHR0WHR4eHh4gIiIgHxsaGhobGxobGxoaAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAdHRYdHR4eHh0dFh0eHR0eIiIiIiAgICAgICAgICAgIBsbGxsaHBwcHBwcHBwcHBoAAAAAAAAAAAAAAAAAAAAA" +
    "HRYdHR0WFh0dHRYdFhYWFgYGBgYGCgYKBgoKCgoKCgYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB0WFh0dHR0e" +
    "HR0WHR0WFh0KCgYKDQ0KDQoNDQ0NDQ0NAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAdHRYdHR4eHh0dFh0eHh4e" +
    "CgoGCgoNCg0NDQ0KDQoKDQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHR0WHRYeHh4dHR0dHh4eHgYKBgoKDQ0N" +
    "DQ0NCg0NDQ0AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABYWHR0WHR4eHR0WFh0dHR0GCgoKCg0NDQ0KDQoNDQ0N" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkJBYWFhYWFhYWJCQkJCQkCgoKCg0NDQ0NCg0NDQ0NDQAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFyUkJCQmJCQkJCUXJSQkJQoKCgoNCg0NDQoNDQ0NCg0AAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAABcXFyUlJCQlJRcXFxclJRcKBgoGCgoNCgoNDQoKDQoKAAAAAAAAAAAAAAAAAAAAAA==",
};

// Extracted from Minecraft Java 26.2 client.jar:
// assets/minecraft/textures/entity/player/slim/alex.png
// Source PNG SHA-256: 99391ed9dff9581ec88daf23b9b028adc9ac91f52889edcff1c982d0923c0cff
const ALEX: EncodedSkin = {
  palette: [
    0, 0, 0, 0, 229, 141, 63, 255, 235, 152, 63, 255, 222, 129, 46, 255, 243,
    168, 88, 255, 223, 196, 162, 255, 212, 183, 143, 255, 235, 208, 176, 255,
    239, 218, 191, 255, 255, 255, 255, 255, 35, 98, 36, 255, 239, 187, 177, 255,
    113, 171, 110, 255, 54, 54, 54, 255, 40, 40, 40, 255, 140, 190, 138, 255,
    134, 185, 132, 255, 92, 59, 39, 255, 128, 130, 90, 255, 123, 178, 120, 255,
    100, 65, 44, 255, 114, 78, 54, 255, 124, 87, 62, 255, 108, 70, 46, 255, 148,
    150, 107, 255, 148, 200, 146, 255, 88, 88, 88, 255, 101, 101, 101, 255, 111,
    111, 111, 255, 63, 63, 63, 255, 79, 79, 79, 255, 24, 56, 22, 255, 43, 84,
    40, 255, 117, 80, 56, 255,
  ],
  indices:
    "AAAAAAAAAAABAgEDAQMBAQECAwECAwICAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AgICAgMDAwICAgMBAgMCAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICBAQCAgMB" +
    "AQIBAwEDAgEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAwMBAgMCAgMBAgEDAQID" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgQEBAQCBAQDAwECAwIBAwAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEDAQICAQECBQYDAwMBAQMAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAgIEAQIBAQUFBQYGBgMDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQQCBAIEBAIFBQcHBwcFBQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAABAgIBBAECAQEEAgQBAgQBAQECBAIBAQIBAgICAQICAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AQQEAgQBAgECBAECAQECBAECAgQEAgEEBAICAgECBAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIEBAECAQIC" +
    "AgECAQUFAQICBAICAgQBAQQCBAIBBAQBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEBAIBAgEBAgICAQcIBwcB" +
    "AgIEAgECAgECBAQBAQQCAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQEBAgEFBQEHCQoICAoJBwEEAgQCAQIB" +
    "AQQCAwIEAQMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAICAgEFBwcICAgICAgICAgFAQQCBAECAQIEAQMEAgED" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAgMBBwcICAgICAsLCAgHBwUEAQQDAgMEAgMCBAIDAQAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgEDBgYFBwcHCAgICAgHBQUBAgMCAwEDAgIDAgIBAwEAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAMDAwMDQ0ODgAAAAAAAAAADxABAQECAgEMDAwMDAwMDAAAAAAAAAAADw8PCAgHAAAAAAAA" +
    "AAAAAAAAAAAAAAAADAwMDA4ODQ0AAAAAAAAAAA8QEAMDAQICDAwRERERDAwAAAAAAAAAAA8PDwgHBgAAAAAAAAAAAAAAAAAA" +
    "AAAAAAwMERENDQ4OAAAAAAAAAAAPEBIGAwMBAgwREREREREMAAAAAAAAAAAPDw8ICAcAAAAAAAAAAAAAAAAAAAAAAAAMERER" +
    "Dg4NDQAAAAAAAAAADxIFBgYBAQEMERERERERDAAAAAAAAAAADw8PCAcGAAAAAAAAAAAAAAAAAAAQDw8TFBUWFBQUDAwQEBAQ" +
    "Dw8PDxASBwUFBhIMDAwMDAwMDAwMDBMQDw8PDw8PDw8QDw8PDw8AAAAAAAAAAAAAFBMTFBcWFhcUFBQUEREUFA8TEw8QGAgH" +
    "BwgSDAwMDBMMDAwMExAPDxAQDw8QDxAQDxAQEA8QAAAAAAAAAAAAABUXFxUWFhcWFRQUFBcVFhYPExMTEBMYCAgSDAwTDAwT" +
    "ExMQDw8ZDxkZDw8ZGRkPDxkZDw8ZDwAAAAAAAAAAAAAWFhUUFBcWFRYXFxcVFhYWDwwTEw8QExgSDAwTEBMMExAZDxkPGQ8Z" +
    "EhISEhISEhISEhISEhIAAAAAAAAAAAAAFxQUFxYWFhUVFxcXERcXFxMMEw8ZDxkPEwwTEBATDA8PGRkPGRkZGQcHBwcHBwUF" +
    "BQUFBQcHAAAAAAAAAAAAABoaGhQXFRUXFBoaGhobGxoTExMPGRkZExkQDxAPEwwTGRkZExkPGRkICAgICAgHBwUFBwcICAAA" +
    "AAAAAAAAAAAbGxsaGhsaGhobGxsbGxsbDxMMDxkZDxMZDxkQDxMTExkPGRMZExkPCAgICAgICAcFBwcICAgAAAAAAAAAAAAA" +
    "GhsbGxscGxsbGxsaHR4eHQ8TEw8ZEw8MGRMZDw8MEw8PExkTDxMZDwgICAgICAgHBQcHCAgIAAAAAAAAAAAAAB0eHh0aGxsa" +
    "HR4eHR4aGh4fHx8gDAwTDA8MDxMgHx8fDBMPEw8TDwwICAgICAgIBwcHBQgICAAAAAAAAAAAAAAaGhoeHR4eHR4aGhoeGhoa" +
    "DBMTDCAgHx8fHyAgDBMTDB8fICAgICAfCAgICAgIBwcHBwUHCAgAAAAAAAAAAAAAHh4aGhocGxoaGh4eHR4eHg8QExMQEA8Q" +
    "DxAPEBMQDw8PDw8TDxAPDwgICAgIBwUFBwcHBQcIAAAAAAAAAAAAAA0dHR4bGxsaHh0dDQ0dHQ0PDxATEBQhISEhFBAQDw8Q" +
    "Ew8PDw8PDw8ICAgICAgHBQcFBwcICAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAECBAIBAQICAgICAQEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAABAECAQAAAQEBAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAgQBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAQCAAAAAAAAAAAAAAAAABgYGBgYEhISEhISEhIYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMDAwR" +
    "Dg4NDQAAAAAAAAAAAg8PBwgIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAwMDA0NDg4AAAAA" +
    "AAAAAAIBDwYHCAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABEREREODg0NAAAAAAAAAAAEAQ8H" +
    "CAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAARERERDQ0ODgAAAAAAAAAABA8PBgcIAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUFBQUFBYVFxQUFBQREw8PDw8QAQIPDw8PDw8PDwEAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFBQUFBQWFhUVFRUXFxERERAQDwECDxAPDxAQEA8QAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAABQUFBcVFxYWFhYWFhYWFRQPGRkPDxkZGQ8PGQ8ZDwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAXFxcVFhYXFBQVFhYWFhYXEhISEhISEhISEhISEhIAABISEhISEhgYGBgYGBISAAAAAAAAAAAAAAAAAAAAAAAA" +
    "FxcXFRUWFhYVFBQXFxcXFwUFBQUFBwcHBwcHBwcFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABoaGhQXFRUX" +
    "FBoaGhobGx4HBQUHBwgICAgICAgIBwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAbGxsaHhsaGhobGxsbGxsa" +
    "BwcFBwgICAgICAgICAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGhsbGxocGxsbGxsaHR4eHQcHBQcICAgI" +
    "CAgICAgIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB0eHh0eGxsaHR4eHR4aGh4FBwcHCAgICAgICAgICAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAaGhoeHR4eHR4aGhoaGhoaBQcHBwcICAgICAgICAcAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHh4aGhocGxoaGh4eHh4eHgcHBwUFBwgICAgICAcFAAAAAAAAAAAAAAAAAAAAAAAA" +
    "AAAAAAAAAAAAAAAAAAAAAA0dHR4bGxsbHh0dDQ0dHQ0HBQcFBwgICAgICAgIBwAAAAAAAAAAAAAAAAAAAAAAAA==",
};

const DEFAULT_PIXELS: Record<SkinModel, Uint8ClampedArray> = {
  classic: decodePixels(STEVE),
  slim: decodePixels(ALEX),
};

export function createDefaultSkin(
  model: SkinModel = "classic",
  size: SkinSize = SKIN_SIZE,
): SkinDocument {
  if (size === SKIN_SIZE)
    return createSkinDocument(DEFAULT_PIXELS[model], model);
  const pixels = new Uint8ClampedArray(size * size * RGBA_CHANNELS);
  const scale = size / SKIN_SIZE;
  for (let y = 0; y < SKIN_SIZE; y += 1) {
    for (let x = 0; x < SKIN_SIZE; x += 1) {
      const source = (y * SKIN_SIZE + x) * RGBA_CHANNELS;
      for (let dy = 0; dy < scale; dy += 1) {
        for (let dx = 0; dx < scale; dx += 1) {
          const target =
            ((y * scale + dy) * size + x * scale + dx) * RGBA_CHANNELS;
          pixels.set(
            DEFAULT_PIXELS[model].subarray(source, source + RGBA_CHANNELS),
            target,
          );
        }
      }
    }
  }
  return createSkinDocument(pixels, model);
}

function decodePixels({
  palette,
  indices: encodedIndices,
}: EncodedSkin): Uint8ClampedArray {
  if (palette.length % RGBA_CHANNELS !== 0) {
    throw new Error("默认皮肤调色板不是有效的 RGBA 数据。");
  }

  const binaryIndices = atob(encodedIndices);
  if (binaryIndices.length !== SKIN_PIXEL_COUNT) {
    throw new Error(
      `默认皮肤索引应包含 ${SKIN_PIXEL_COUNT} 个像素，收到：${binaryIndices.length}`,
    );
  }

  const pixels = new Uint8ClampedArray(SKIN_PIXEL_COUNT * RGBA_CHANNELS);
  for (let pixel = 0; pixel < SKIN_PIXEL_COUNT; pixel += 1) {
    const paletteOffset = binaryIndices.charCodeAt(pixel) * RGBA_CHANNELS;
    if (paletteOffset + RGBA_CHANNELS > palette.length) {
      throw new Error("默认皮肤包含超出调色板范围的颜色索引。");
    }
    const pixelOffset = pixel * RGBA_CHANNELS;
    for (let channel = 0; channel < RGBA_CHANNELS; channel += 1) {
      pixels[pixelOffset + channel] = palette[paletteOffset + channel];
    }
  }
  return pixels;
}
